import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getIncidentFeedQuery,
  getBehaviourCategoriesQuery,
  getBehaviourSeveritiesQuery,
  getBehaviourLocationsQuery,
  getMultiLevelBehaviourCategoryQuery,
  getStaffListQuery,
  getBehaviourActionsQuery,
  getStudentBehaviourOverviewQuery,
  getStaffGradesQuery,
  getACLPermissionStaffQuery,
} from "./BehaviourManagementQueries";

export const getBehaviourLocationsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getBehaviourLocationsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getBehaviourCategoriesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getBehaviourCategoriesQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getBehaviourSeveritiesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getBehaviourSeveritiesQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getMultiLevelBehaviourCategoriesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getMultiLevelBehaviourCategoryQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getBehaviourActionsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getBehaviourActionsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStaffListFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStaffListQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getIncidentFeedFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getIncidentFeedQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeIncidentFeedToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getIncidentFeedQuery,
      variables,
      data,
    });
  } catch (e) {
    return {};
  }
};

export const getStaffGradesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStaffGradesQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getStudentBehaviourOverviewQueryFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getStudentBehaviourOverviewQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getACLPermissionStaffFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getACLPermissionStaffQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};
